import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private promptEvent: any;
  private isInstallableSubject = new BehaviorSubject<boolean>(false);
  public isInstallable$ = this.isInstallableSubject.asObservable();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private deviceService: DeviceDetectorService
  ) {
    if (isPlatformBrowser(this.platformId) && environment.enablePwa) {
      this.initPwa();
    }
  }

  private initPwa() {
    window.addEventListener('beforeinstallprompt', (event: any) => {
      // Prevent the mini-infobar from appearing on mobile
      event.preventDefault();
      // Stash the event so it can be triggered later.
      this.promptEvent = event;
      // Notify the UI that the app is installable
      this.isInstallableSubject.next(true);
    });

    window.addEventListener('appinstalled', () => {
      // Hide the app-provided install promotion flow
      this.isInstallableSubject.next(false);
      this.promptEvent = null;
      console.log('PWA was installed');
    });
  }

  public installPwa() {
    if (this.promptEvent) {
      this.promptEvent.prompt();
      this.promptEvent.userChoice.then((choiceResult: { outcome: string }) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        this.promptEvent = null;
        this.isInstallableSubject.next(false);
      });
    }
  }

  public isIos(): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  }

  public isInStandaloneMode(): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    return (
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      (window.navigator as any).standalone === true
    );
  }
}
